var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.key,staticClass:"spinner-container",style:({ top: _vm.scrollY })},[_c('div',{staticClass:"spinner-box"},[_c('ClipLoader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }